
import request from '@/utils/pay_request'

// 获取支付页面选项--购买会员
export function getPageOptionMember(params) {
  return request({
    url: 'pay/money/getPageOptionMember',
    method: 'get',
    params
  })
}
// 获取二维码--购买会员
export function getOrderCode(params) {
  return request({
    url: 'pay/order/getOrderCode',
    method: 'get',
    params
  })
}
// 扫码支付是否成功
export function isSuccessForCode(params) {
  return request({
    url: 'pay/order/isSuccessForCode',
    method: 'get',
    params
  })
}
